import { create } from 'zustand';

const useFiltersStore = create(set => ({
  open: new Set(),
  showType: new Set(['Gallery']),
  selectedMediums: new Set(),
  selectedStyles: new Set(),
  selectedSubject: new Set(),
  selectedLocation: new Set(),
  sortedByRelevance: true,

  setAllArtMedium: () => set({ selectedMediums: new Set() }),
  addToFilter: (key, value) =>
    set(state => {
      // Only allow one filter at a time for 'open' or 'showType'
      if (key === 'open' || key === 'showType') {
        return {
          ...state,
          [key]: new Set([value]),
        };
      } else {
        const newSet = new Set(state[key]);
        newSet.add(value);
        return { ...state, [key]: newSet };
      }
    }),

  removeFromFilter: (key, value) =>
    set(state => {
      const newSet = new Set(state[key]);
      newSet.delete(value);
      return { ...state, [key]: newSet };
    }),

  sortedByRelevanceToggle: () =>
    set(state => ({
      ...state,
      sortedByRelevance: !state.sortedByRelevance,
    })),

  resetFilters: () =>
    set({
      open: new Set(),
      selectedMediums: new Set(),
      selectedStyles: new Set(),
      selectedSubject: new Set(),
      selectedLocation: new Set(),
      showType: new Set(),
    }),

  clearLocationFilters: () =>
    set(state => ({
      ...state,
      selectedLocation: new Set(),
    })),

  clearCityScopedFilters: () =>
    set(state => ({
      ...state,
      selectedLocation: new Set(),
      showType: new Set(),
      open: new Set(),
    })),

  // Derived state to keep track of the number of items in each set
  getCounts: () => {
    const state = useFiltersStore.getState();
    return {
      openCount: state.open.size,
      selectedMediumsCount: state.selectedMediums.size,
      selectedStylesCount: state.selectedStyles.size,
      selectedSubjectCount: state.selectedSubject.size,
      selectedLocationCount: state.selectedLocation.size,
      showTypeCount: state.showType.size,
    };
  },
}));

export default useFiltersStore;
